// Keep post-auth redirects inside the product shell. This avoids treating an
// arbitrary location state value as a navigation target.
export function getSafeReturnPath(from) {
  const pathname = from?.pathname;
  if (typeof pathname !== "string" || !pathname.startsWith("/app/")) return null;
  return `${pathname}${typeof from.search === "string" ? from.search : ""}${typeof from.hash === "string" ? from.hash : ""}`;
}

export function getPostAuthDestination({ from, isNewUser = false } = {}) {
  return getSafeReturnPath(from) || (isNewUser ? "/app/explore?welcome=1" : "/app/explore");
}
